import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';

class NotifyMsg extends Component{
  constructor(props) {
      super(props);
       this.state = {
          startTime: Date.now(),
          elapsed: 0,
          fadeOutMs: 5000
       };
       this.timer = setInterval(this.timeWatcher, 1000);
    }
  componentWillUnmount = () => {
    clearInterval(this.timer);
  };
  timeWatcher = () => {
     if (this.state.elapsed > this.state.fadeOutMs){
      this.props.dismissAlert(this.props.index);
    }else {
      this.setState({elapsed: Date.now() - this.state.startTime});
    }
  };
  handleClose = () => {
    this.props.dismissAlert(this.props.index);
  };
  render()  {
      if (['success', 'info', 'warning', 'danger'].indexOf(this.props.alert.alertType) < 0) {
        this.props.alert.alertType = 'info';
      }
      var css = 'animated bounceInRight alert alert-dismissible alert-' + this.props.alert.alertType;
      var headline = this.props.alert.headline ? <strong>{this.props.alert.headline}&nbsp;</strong> : null;
      return (
        <div className={css} key={this.props.alert.id}>
          <button
            className="close"
            onClick={this.handleClose}
            title="luk"
            type="button">
            &times;
          </button>
            {headline}
            {this.props.alert.msg}
        </div>
      );
  }
}
  NotifyMsg.propTypes = {
    alert: PropTypes.shape({
      alertType: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      msg: PropTypes.string.isRequired
    }).isRequired,
    index: PropTypes.number.isRequired,
    dismissAlert: PropTypes.func.isRequired
  };
export default Radium(NotifyMsg);


// WEBPACK FOOTER //
// ./src/App/MsgNotify/NotifyMsg.jsx